import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import {
  setIframeUserRole,
  setUserRole,
  userDetailBroker,
  userDetailIframeUser,
} from "../redux/user/actions";
import { loginIframeUserResponse } from "../redux/auth/actions";
import { clickStreamUser } from "../utils/AppUtils";
import PodcastAndFBFeedSection from "./PodcastAndFBFeedSection";
import CONFIG from "../utils/config";
import $ from "jquery";
import { SessionKeys } from "../utils/AppUtils";
import Loader from "./Loader/Loader";

export default function PodcastAndFBFeedMobile() {
  const dispatch = useDispatch();

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const token = params.get("token");
  const key = params.get("key");
  const username = params.get("username");
  const user_id = params.get("user_id");
  const color_1 = params.get("color_1");
  const color_2 = params.get("color_2");
  const role = params.get("role");

  const [isLoading, setIsLoading] = useState(true);
  const [isValidKey, setIsValidKey] = useState(false);

  useEffect(() => {
    if (key === CONFIG.KEY.MOBILE_ACCESS_KEY) {
      $("html").css(
        "--color-element-1",
        color_1 ? "#" + color_1 : CONFIG.COLOR_ELEMENT_1
      );
      $("html").css(
        "--color-element-2",
        color_2 ? "#" + color_2 : CONFIG.COLOR_ELEMENT_2
      );
      localStorage.setItem(SessionKeys.API_TOKEN, token);
      localStorage.setItem(SessionKeys.IFRAME_USERNAME, username);
      localStorage.setItem(SessionKeys.USER_ID, user_id);
      setIsValidKey(true);
      dispatch(setIframeUserRole(role));
      dispatch(
        loginIframeUserResponse({
          payload: {
            user: {
              user_id: user_id,
              username: username,
              role: [role],
            },
            apiToken: token,
          },
        })
      );
      dispatch(setUserRole(role));
      // dispatch(
      //   userDetailIframeUser({
      //     module: "getOrderDetailBroker",
      //     apiToken: token,
      //   })
      // );
      dispatch(
        userDetailBroker({
          module: "getOrderDetailBroker",
          apiToken: token,
        })
      );
      clickStreamUser("report_mobile_page", {
        userId: user_id,
      });
      setIsLoading(false);
    }
  }, [token, key, user_id, dispatch]);

  useEffect(() => {
    if (document.getElementById("id_page_404") !== null) {
      document.getElementById("id_page_404").style.display = "none";
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => {
      if (document.getElementById("cc_div") !== null)
        document.getElementById("cc_div").style.display = "none";
    }, 100);
  }, []);
  return (
    <>
      {" "}
      {isValidKey ? (
        <>
          <Loader start={isLoading} />
          <PodcastAndFBFeedSection
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            isMobile={true}
          />
        </>
      ) : (
        <div>Invalid Key</div>
      )}
    </>
  );
}
